import { useMemo } from "react";
import ParagraphWithVideo from "template-store/components/paragraph-with-video/paragraph-with-video";
import ParagraphWithDemoComponent from "template-store/components/paragraph-with-demo/paragraph-with-demo-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getSolutionCategoryIds } from "template-store/services/solution-data-service";
import { getCloudinartDemoVideoURLForCategory } from "template-store/services/solution-categories-service";
import { componentStyles } from "./template-feature-content.scss";
import BulbIcon from "static/svg/templates-store//bulb.svg";

const TemplateFeatureContent = (props) => {
  const {
    templateData,
    translate,
    featureTitleKey,
    featureDescriptionKey,
    subsectionTitleKey,
    subsectionDescriptionKey,
    demoComponent,
    demoComponentMetadata,
    templateDataFieldName,
    demoVideoFileName
  } = props;

  const videoSrc = useMemo(() => {
    const firstCategory = getSolutionCategoryIds(templateData)[0];
    return getCloudinartDemoVideoURLForCategory(firstCategory, demoVideoFileName);
  }, [demoVideoFileName, templateData]);

  return (
    <div className="template-feature-content">
      <div className="paragraph-with-image-wrapper">
        <ParagraphWithVideo
          title={translate(featureTitleKey)}
          description={translate(featureDescriptionKey)}
          videoSrc={videoSrc}
        />
        <div className="demo-component-wrapper">
          <ParagraphWithDemoComponent
            title={translate(subsectionTitleKey)}
            description={translate(subsectionDescriptionKey)}
            templateData={templateData}
            icon={BulbIcon}
            demoComponent={demoComponent}
            demoComponentMetadata={demoComponentMetadata}
            templateDataFieldName={templateDataFieldName}
          />
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(TemplateFeatureContent);
